const state = {
  moduleList: [], // 模块列表
  indexNewsList: [], // 基金会动态
}

const mutations = {
  SET_MODULE_LIST: (state, list) => {
    state.moduleList = list
  },

  SET_INDEX_NEWS_LIST: (state, list) => {
    state.indexNewsList = list
  },
}

const actions = {
  setModuleList({
    commit
  }, list) {
    commit('SET_MODULE_LIST', list)
  },

  setIndexNewsList({
    commit
  }, list) {
    commit('SET_INDEX_NEWS_LIST', list)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
